<template>

    <div>
        <div class="save_position_btn_container">
            <a class="button is-info is-rounded is-outlined" :disabled="!isPositionValid" @click="updatePosition">
                {{ $t('modules.positions.topbar.saveButton') }}
            </a>
        </div>

        <transition name="notif-slide-up">
            <alert v-if="positionSaveNotif" context="success" @close="positionSaveNotif=false">{{ $t('modules.positions.topbar.saveAlertSuccess') }}</alert>
        </transition>
    </div>

</template>

<script>
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'TopbarSaveBtnPosition',
    components: {},
    data(){
        return {
            positionSaveNotif: false
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        formValidity(){
            return this.$store.state.PositionStore.formValidity
        },
        isPositionValid(){
            return (this.formValidity[0] && this.formValidity[1] && this.formValidity[2])
        }
    },
    methods:{
        updatePosition(){
            if( userCanAccess('features', 'create_sight_group') ){
                if(this.isPositionValid){

                    this.$store.dispatch('PositionStore/updatePosition').then(resp => {
                        this.positionSaveNotif = true
                    }).catch(err => {
                        console.log('save_error')
                    })

                }
            }else{
                this.$router.push('/unautorized'); 
            }
        }
    }
}
</script>

<style lang="scss">
    .save_position_btn_container{
        max-width: 160px;
        min-width: 160px;
        display: flex;
        height: 60px;
        justify-content: center;
        align-items: center;
    }
</style>